import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import FormInput from '../../common/FormInput/FormInput'; 
import Constant from '../../static/data/Constant';
import { generateId } from '../../common/util/Functions';
import { InputContent, ErrorItem, StringObject, Translations } from '../../types';
import { useSiteLang, useTranslation } from '../../common/util/Hook';

import './LoggInnPaAvtale.scss';

export interface LoggInnPaAvtaleProps {
    useH2?: boolean;
    // eslint-disable-next-line
    submit?: (data: StringObject) => void;
    standAlone?: boolean;
    failed?: string;
}

interface State {
    id: string;
    formAction: any;
    content: InputContent[];
}

const getInputContent = (translated: Translations): InputContent[] => {
    return [
        {
            id: 'mobileCustomerId',
            name: 'customerId',
            label: translated.fnr,
            type: Constant.typeTel,
            required: true,
            maxLength: 11,
            namespace: 'customer-id',
            validation: [
                {
                    rule: Constant.validationRequired,
                    message: translated.fnrPakrevd,
                }, {
                    rule: Constant.validationPersonId,
                    message: translated.fnrError,
                }
            ]     
        }, {
            id: 'otp',
            name: 'otp',
            label: translated.kodebrikke,
            type: Constant.typeTel,
            required: true,
            maxLength: 6,
            namespace: 'code-id',
            validation: [
                {
                    rule: Constant.validationRequired,
                    message: translated.kodebrikkePakrevd,
                }, {
                    rule: Constant.validationCodeNumber,
                    message: translated.kodebrikkeError,
                }
            ]            
        },
    ];
};

const submit = (props: LoggInnPaAvtaleProps, data: StringObject, errorList: ErrorItem[]): void => {
    if ( errorList.length ) { return; }
    if ( props.submit ) { props.submit(data); }
};

const LoggInnPaAvtale: React.FC<LoggInnPaAvtaleProps> = (props): React.ReactElement => {
    const translated = useTranslation();
    const [state, setState] = useState<State>({
        id: generateId('login-code'),
        formAction: useForm<any>({mode: 'onBlur'}),
        content: getInputContent( translated ),
    });

    const { siteLang } = useSiteLang();
    useEffect(() => {
        setState(prevState => {
            return {
                ...prevState,
                content: getInputContent(translated)
            }
        });
    }, [siteLang, translated]);

    return (
        <div id={state.id} className={classNames('logg-inn-pa-avtale-wrapper', {'stand-alone-wrapper': !!props.standAlone})}>
            { props.useH2 ?
                <h2 className="paragraph">{translated.aktiverBankId}</h2> :
                <h1 className="paragraph">{translated.aktiverBankId}</h1>
            }
            <p>{translated.forsideBeskrivelse1}</p>
            <p>{translated.forsideBeskrivelse2}</p>
            <FormInput
                content={state.content} 
                formAction={state.formAction} 
                submitText={translated.neste}
                submitCallback={ (data: StringObject, errorList: ErrorItem[]) => { submit(props, data, errorList)}}
                failed={props.failed}
            />
        </div>
    );
};

export default LoggInnPaAvtale;
